<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="27" y="11" width="46" height="78" rx="4" stroke="black" stroke-width="4"/>
<rect x="34" y="25" width="32" height="46" stroke="black" stroke-width="4"/>
<path d="M62 18L48.1111 18M43.9444 18L37 18" stroke="black" stroke-width="4"/>
<circle cx="50" cy="80" r="3" stroke="black" stroke-width="4"/>
</svg>

</template>
